module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0052.jpg?v=2642ad6f";